export default {
      id: "burger-menu-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.9328ef59.svg#burger-menu",
      toString: function () {
        return this.url;
      }
    }